/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Leave_Confirm_BodyInputs */

const en_us2_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You stop showing in the club. Your workouts stay yours.`)
};

const pt_br2_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você deixa de aparecer no clube. Seus treinos continuam seus.`)
};

const es_419_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dejas de aparecer en el club. Tus entrenamientos siguen siendo tuyos.`)
};

const pt_pt2_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deixas de aparecer no clube. Os teus treinos continuam teus.`)
};

const fr_fr2_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu n'apparais plus dans le club. Tes séances restent à toi.`)
};

const de_de2_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du erscheinst nicht mehr im Club. Deine Trainings bleiben deine.`)
};

const it_it2_clubs_leave_confirm_body = /** @type {(inputs: Clubs_Leave_Confirm_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non apparirai più nel club. I tuoi allenamenti restano tuoi.`)
};

/**
* | output |
* | --- |
* | "You stop showing in the club. Your workouts stay yours." |
*
* @param {Clubs_Leave_Confirm_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_leave_confirm_body = /** @type {((inputs?: Clubs_Leave_Confirm_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Leave_Confirm_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_leave_confirm_body(inputs)
	if (locale === "es-419") return es_419_clubs_leave_confirm_body(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_leave_confirm_body(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_leave_confirm_body(inputs)
	if (locale === "de-DE") return de_de2_clubs_leave_confirm_body(inputs)
	if (locale === "it-IT") return it_it2_clubs_leave_confirm_body(inputs)
	return en_us2_clubs_leave_confirm_body(inputs)
});
export { clubs_leave_confirm_body as "clubs.leave_confirm_body" }